import React, { Component, ReactNode, RefObject, createRef } from "react";
import { Renderer } from "vexflow";
import { Handler, SCORE_STORE_KEY } from "../common/handler";

//import styles
import "weui";
import "react-weui-ts/build/dist/react-weui.css";

import "../styles/vexEditor.css";
import axios from "axios";
import { getUrlParam } from "../utils/helpers";
import { base_url } from "../config";
import ViewerTopNavBar from "./ViewerTopNavBar";

export default class VexViewer extends Component {
  private containerRef: RefObject<HTMLCanvasElement> = createRef();

  private handler: Handler | null = null;

  state = {
    handler: null,
    sharpUpStatus: 0,
    sharpDownStatus: 0,
    showChordPopup: false,
    title: "",
  };

  async componentDidMount() {
    const render = new Renderer(
      this.containerRef.current ?? "",
      Renderer.Backends.CANVAS
    );
    render.resize(2000, 260);

    const handler = Handler.getInstance(render);

    const scoreString = localStorage.getItem(SCORE_STORE_KEY);
    let score = undefined;

    if (scoreString != null) {
      score = JSON.parse(scoreString);
    }

    const uuid = getUrlParam("id");
    const openid = getUrlParam("openid");

    let res: any;
    try {
      res = await axios.get(`${base_url}/staff`, {
        params: {
          id: uuid,
          openid: openid,
        },
      });

      if (res?.status == 200 && res?.data?.data?.content) {
        score = JSON.parse(res.data.data?.content);
        this.setState({ title: res.data.data?.title });
      } else {
        console.error("获取乐谱失败", res?.data?.data);
        this.setState({ title: "新建乐谱" });
      }
    } catch (e) {
      console.error("获取乐谱失败", e);
    }

    handler.init(score);
    this.handler = handler;
    this.setState({ handler });
  }

  componentWillUnmount(): void {}

  render(): ReactNode {
    return (
      <React.Fragment>
        <ViewerTopNavBar
          title={this.state.title}
          handler={this.state.handler}
        ></ViewerTopNavBar>
        <div className="canvas-container">
          <canvas ref={this.containerRef} />
        </div>
      </React.Fragment>
    );
  }
}
